import { render } from "./PreviousPageLink.vue?vue&type=template&id=7815de19&scoped=true"
import script from "./PreviousPageLink.vue?vue&type=script&lang=js"
export * from "./PreviousPageLink.vue?vue&type=script&lang=js"

import "./PreviousPageLink.vue?vue&type=style&index=0&id=7815de19&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7815de19"

export default script